<script>
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";

// Custom components
import PageHeader from "@/components/page-header";
import AccountService from "@/helpers/APIService/account.service";
import PaymentAccount from "./subAccount.vue";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Account Component
export default {
  page: {
    title: "Payment Methods",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    PaymentAccount,
  },
  data() {
    return {
      title: "Payment Methods",
      table: {
        tableData: [],
        next: null,
        previous: null,
        count: 10,
        total_pages: 1,
        page_number: 1,
        per_page: 10,
        from: 1,
        to: 10,
      },
      AddNewPaymentMethod: false,
      is_data_loading: true,
      isLoading: true,
      addAccountModel: false,
      selectedPaymentMethod: null,
      isEdit: false,
      submitted: false,
      is_btn_loading: false,
      account: {
        name: "",
        is_display: true,
        id: "",
        index: 0,
      },
      createError: false,
      errorMessage: null,
      paymentMethodNameList: [],
      isUniqueValue: false,
      uniqueValueMessage: {
        name: "",
      },
    };
  },
  validations: {
    account: {
      name: { required },
    },
  },
  computed: {
    ...authComputed,
    paymentAccountProps() {
      return {
        selectedPaymentMethod: this.selectedPaymentMethod,
      };
    },
  },
  mounted() {
    this.getPaymentAccountBrifListData();
  },
  methods: {
    async getPaymentAccountBrifListData() {
      await AccountService.getPaymentMethodBrifList()
        .then((account) => {
          account.map((item) => {
            this.paymentMethodNameList.push(item.name.toLowerCase());
          });
          this.table.tableData = account;
        })
        .catch((error) => {
          errorHandler(error);
          this.isBtnLoading = false;
          this.createError = true;
          if (typeof error.response.data.non_field_errors == "object") {
            this.errorMessage = error.response.data.non_field_errors;
          } else {
            this.errorMessage = error.response.data;
          }
        });
      this.isLoading = false;
      this.is_data_loading = false;
    },
    accountModel() {
      this.addAccountModel = !this.addAccountModel;
      this.$refs["add-account-modal"].show();
    },
    accountAddedUpdated() {
      this.paymentMethodNameList = [...new Set(this.paymentMethodNameList)];
      this.isUniqueValue = false;
      this.is_btn_loading = true;
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.is_btn_loading = false;
        return;
      } else {
        if (this.isEdit) {
          this.paymentMethodNameList.splice(this.account.name.toLowerCase());
        }
        if (
          this.paymentMethodNameList.includes(
            this.account.name.toLowerCase().trim()
          )
        ) {
          this.is_btn_loading = false;
          this.isUniqueValue = true;
          this.uniqueValueMessage.name = "name must be unique.";
        } else {
          this.uniqueValueMessage.name = "";
        }
        if (!this.isUniqueValue) {
          if (this.isEdit == true) {
            let accountData = new FormData();
            accountData.append("name", this.account.name);
            accountData.append("is_display", this.account.is_display);

            AccountService.editMethod(this.account.id, accountData).then(
              (account) => {
                this.table.tableData[this.account.index] = account;
                this.is_btn_loading = false;
                this.isEdit == false;
                this.submitted = false;
                this.$refs["add-account-modal"].hide();
                Middleware.notification("Successfully updated !!", "success");
              },
              (error) => {
                errorHandler(error);
                this.isBtnLoading = false;
                this.createError = true;
                if (typeof error.response.data.non_field_errors == "object") {
                  this.errorMessage = error.response.data.non_field_errors;
                } else {
                  this.errorMessage = error.response.data;
                }
              }
            );
          } else {
            let accountData = new FormData();
            accountData.append("hotel", this.hotel.id);
            accountData.append("name", this.account.name);
            accountData.append("is_display", this.account.is_display);

            AccountService.addMethod(accountData)
              .then((account) => {
                this.table.tableData.push(account);
                this.is_btn_loading = false;
                this.submitted = false;
                this.$refs["add-account-modal"].hide();
                Middleware.notification("Successfully added !!", "success");
              })
              .catch((error) => {
                this.isBtnLoading = false;
                this.createError = true;
                errorHandler(error);

                if (typeof error.response.data.non_field_errors == "object") {
                  this.errorMessage = error.response.data.non_field_errors;
                } else {
                  this.errorMessage = error.response.data;
                }
              });
          }
        }
      }
    },
    async editMethod(id, name, index) {
      this.account.name = name;
      this.account.id = id;
      this.account.index = index;
      this.isEdit = true;
      this.$refs["add-account-modal"].show();
    },
    deleteMethod(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          AccountService.deleteMethod(id).then(
            () => {
              Middleware.notification("Successfully deleted !!", "danger");

              this.table.tableData.splice(index, 1);
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    resetModal() {
      this.isEdit = false;
      this.submitted = false;
      this.is_btn_loading = false;
      this.account.name = "";
      this.account.is_display = true;
      this.account.id = "";
      this.account.index = 0;
      this.isUniqueValue = false;
      this.uniqueValueMessage = {
        name: "",
      };
    },
    getPaymentAccount(data) {
      this.selectedPaymentMethod = data;
    },
    addNewPaymentMethod(id) {
      this.$root.$emit("AddNewPaymentMethod", id);
    },
    cancelSubmit() {
      this.$refs["add-account-modal"].hide();
      this.resetModal();
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :isButton="true"
      :action="accountModel"
      text="New Payment Method"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <!-- Loading areas -->
                <template v-if="isLoading">
                  <b-card
                    v-for="number in 4"
                    :key="number"
                    class="placeholder-glow"
                  >
                    <span
                      class="placeholder w-100 placeholder-lg"
                      style="height: 20px"
                    ></span>
                  </b-card>
                </template>
                <b-card
                  no-body
                  class="shadow-none"
                  v-for="(data, index) in table.tableData"
                  :key="data.id"
                >
                  <b-card-header
                    header-tag="header"
                    role="tab"
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h6
                      class="float-start mt-2 w-75"
                      slot="header"
                      v-b-toggle="data.id"
                      @click="getPaymentAccount(data)"
                    >
                      <span class="fs-5">
                        {{ data.name }}
                      </span>
                      <sub>
                        ( Total Billed :
                        <a href="javascript: void(0);">
                          {{ data.debit_total }}
                        </a>
                        , Total Outstanding :
                        <a href="javascript: void(0);">
                          {{
                            parseFloat(
                              data.debit_total - data.credit_total
                            ).toFixed(2)
                          }} </a
                        >)</sub
                      >
                    </h6>
                    <div class="d-flex align-items-center float-end">
                      <a href="javascript: void(0);">
                        <i
                          v-if="data.is_deleted"
                          class="fas fa-pencil-alt text-success fs-5"
                          v-b-popover.hover="'Update payment method'"
                          @click="editMethod(data.id, data.name, index)"
                        ></i>
                        <i
                          v-if="data.is_deleted"
                          class="ms-2 mdi mdi-trash-can text-danger fs-4"
                          v-b-popover.hover="'Delete payment method'"
                          @click="deleteMethod(data.id, index)"
                        ></i>
                      </a>
                    </div>
                  </b-card-header>
                  <b-collapse
                    :id="data.id"
                    accordion="my-accordion"
                    role="tabpanel"
                    class="p-3"
                  >
                    <div class="mb-3">
                      <div
                        class="d-flex flex-wrap justify-content-between align-items-center"
                      >
                        <h5>Payment Accounts</h5>
                        <b-button
                          variant="primary"
                          @click="addNewPaymentMethod(data.id)"
                          size="sm"
                        >
                          Add Payment Account
                        </b-button>
                      </div>
                    </div>
                    <div>
                      <PaymentAccount
                        :currentProps="paymentAccountProps"
                        v-if="
                          selectedPaymentMethod !== null
                            ? selectedPaymentMethod.id === data.id
                            : false
                        "
                      />
                    </div>
                  </b-collapse>
                </b-card>
                <!-- Empty data image loader -->
                <div
                  v-if="!isLoading && table.tableData.length == 0"
                  class="w-100"
                >
                  <span class="d-flex justify-content-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                  </span>
                  <span class="text-center">
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Model is for payment method -->
    <b-modal
      ref="add-account-modal"
      centered
      :title="!isEdit ? 'Add Payment Method' : 'Update Payment Method'"
      @close="resetModal"
      @hidden="resetModal"
      hideFooter
    >
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Account" label-for="email-input" class="mb-3">
            <template slot="label">
              Payment Method <span class="text-danger">*</span>
            </template>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              v-model="account.name"
              required
              :class="{
                'is-invalid':
                  (submitted && $v.account.name.$error) ||
                  (isUniqueValue && uniqueValueMessage.name !== ''),
              }"
            />
            <div
              v-if="submitted && $v.account.name.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.account.name.required">Name is required.</span>
            </div>
            <div v-if="isUniqueValue" class="invalid-feedback">
              <span v-if="uniqueValueMessage.name !== ''">{{
                uniqueValueMessage.name
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h4 v-if="createError">
            <template v-if="typeof errorMessage == 'object'">
              <span v-for="error in errorMessage" :key="error">
                <span class="badge card-badge badge-soft-danger">
                  <b>{{ error }}</b>
                </span>
                <br />
              </span>
            </template>
            <template v-else>
              <span class="badge card-badge badge-soft-danger">
                <b>{{ errorMessage }}</b>
              </span>
            </template>
          </h4>
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="cancelSubmit"
            >Cancel
          </b-button>
          <b-button
            variant="outline-primary"
            class="float-end"
            @click="accountAddedUpdated"
            :class="{
              disabled: is_btn_loading,
            }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle"
              v-if="is_btn_loading"
            ></i>
            {{ isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
